import {createExpense} from '../expenses/expenseService';
import {createTrip} from '../travel/travelService';
import {supabase, clientForAccessToken} from '../supabase/client';
import {draftStore} from './draftStore';
import {createQueueEngine} from './queueEngine';
export const OFFLINE_DRAFTS_KEY = 'silatrail.offline_drafts';
export const OFFLINE_DRAFTS_EVENT = 'silatrail:offline-drafts-updated';
const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('silatrail-device-records') : null;
const changed = () => window.dispatchEvent(new CustomEvent(OFFLINE_DRAFTS_EVENT));
if (channel) channel.onmessage = changed;
const queue = createQueueEngine({store: draftStore, saveExpense: createExpense, saveTrip: createTrip,
  getUser: async () => {
    const {data: sessionData, error: sessionError} = await supabase.auth.getSession();
    if (sessionError) throw sessionError;
    const token = sessionData.session?.access_token;
    if (!token) return null;
    const {data, error} = await supabase.auth.getUser(token);
    if (error) throw error;
    return {...data.user, client: clientForAccessToken(token)};
  },
  locks: navigator.locks, notify: () => { changed(); channel?.postMessage('changed'); }
});
export async function migrateOfflineDrafts(userId) {
  const raw = localStorage.getItem(OFFLINE_DRAFTS_KEY);
  const old = raw ? JSON.parse(raw) : [];
  if (!Array.isArray(old)) throw new Error('Older device records need recovery. They have not been deleted.');
  const drafts = old.filter(x => x.data?.userId === userId).map(x => {
    const id = x.data.values.submissionId || x.id;
    return {...x, id, key: `${userId}:${id}`, status: x.lastError ? 'failed' : 'pending',
      data: {...x.data, values: {...x.data.values, submissionId: id, receipt: []}}};
  });
  await draftStore.importLegacy(userId, drafts);
}
export const getOfflineDrafts = userId => userId ? draftStore.list(userId) : Promise.resolve([]);
export const enqueueOfflineDraft = (type, data) => queue.enqueue(type, data);
export const syncOfflineDrafts = userId => queue.sync(userId);

export async function removeDeviceDraft(draft) {
  const remove = async () => {
    const {data} = await supabase.auth.getSession();
    if (data.session?.user?.id !== draft.data.userId) throw new Error('Sign in to the account that saved this record.');
    await draftStore.remove(draft.key, draft.data.userId);
    changed(); channel?.postMessage('changed');
  };
  return navigator.locks ? navigator.locks.request('silatrail-device-sync', remove) : remove();
}
